<template>
  <Home v-if="!isAdmin" />
  <AdminIndex v-else-if="isAdmin" />
</template>

<script>
import Home from "./views/Home";
import AdminIndex from "./views/AdminIndex";
export default {
  components: { Home, AdminIndex },
  data() {
    return {
      routPath: window.location.href,
      isAdmin: false,
    };
  },
  created() {
    this.isAdmin = this.checkAdmin();
  },
  methods: {
    checkAdmin() {
      return this.routPath.indexOf("/admin") !== -1;
    },
  },
};
</script>
<style></style>
